import { cacheConfig, http } from '../helpers/axiosHelper';

export default class pageTypeService {
   async getPageTypes() {
      return await http.get(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/page-type', { ...cacheConfig }).then((response) => {
         return response.data;
      });
   }
}
